/**
 * javaåå°è¿åæ°æ®åºç¡æ¨¡å
 */

export interface ResponseBase<T> {
    resultCode: number;
    data?: T;
    resultMsg: string;
    detailMsg?: string;
    status: number;
    message: string;
    msg: string;
}

/**
 * è½¬æ¢ResponseBaseï¼å¤çå¼å¸¸
 */
export function transformResponse<T>(response: ResponseBase<T>): T {
    switch (response.resultCode) {
        case 1111:
            return response.data;
        // ç³»ç»æªç¥å¼å¸¸
        case 9999:
        // è´¦å·å¼å°ç»å½
        case 7777:
        // æç¤ºç¨æ·æªç»å½
        case 9998:
        // æç¤ºç¨æ·æ²¡æè¯¥æé
        case 9997:
        // è¯·æ±åæ°æ ¡éªå¼å¸¸
        case 100000001:
        // æ°æ®åºæä½å¼å¸¸
        case 100000002:
        // è¿ç¨è°ç¨å¼å¸¸
        case 100000003:
        // æå¡å¨åé¨å¼å¸¸
        case 100000004:
        case 100101:
        case 100100:
        case 0:
        case 2222:
        default:
            throw new Error(`${response.resultMsg} ${response.resultCode}`);
    }
}

export class Base {
    public id?: string;
    public creatorId?: string;
    public modifierId?: string;
    public updateTime?: string;
    public updateId?: string;
    public createdAt?: string;
    public createTime?: string;
    public createId?: string;
    public status?: number;
    public startTime?: string;
    public endTime?: string;
    public searchWord?: string;
}

export class PageInfo<T> {
    public pageData?: T;
    public list: T[] = [];
    public pageSize = 10;
    public nowPage = 1;
    public rowCount: number;
    public keyWord: string;
    public count: number;
    public rows: T[] = [];
}

export class SelectItem extends Base {
    public name?: string;
    public value?: number | string;
    public disabled?: boolean;
}
